import React, { useMemo, useCallback } from 'react'
import SectionContainer from '../../../../../Homepage/SectionContainer'
import BreadCrumb from '../../../../../component/BreadCrumb/BreadCrumb'
import img1 from "../../../../../assets/kangaroo/brandMark1.jpg"
import primaryLogo from "../../../../svg/primaryLogo.svg"
import secondaryLogo from "../../../../svg/secondaryLogo.svg"
import primaryDownload1 from "../../../../../assets/downloads/KEF~Primary_Logo~CMYK.ai"
import primaryDownload2 from "../../../../../assets/downloads/KEF~Primary_Logo~RGB.ai"
import primaryDownload3 from "../../../../../assets/downloads/KEF~Primary_Logo~CMYK.pdf"
import primaryDownload4 from "../../../../../assets/downloads/KEF~Primary_Logo~RGB.pdf"
import primaryDownload5 from "../../../../../assets/downloads/KEF~Primary_Logo~CMYK.jpg"
import primaryDownload6 from "../../../../../assets/downloads/KEF~Primary_Logo~RGB.jpg"
import primaryDownload7 from "../../../../../assets/downloads/KEF~Primary_Logo~RGB.png"
import secondaryDownload1 from "../../../../../assets/downloads/Secondary_CMYK.ai"
import secondaryDownload2 from "../../../../../assets/downloads/Secondary_RGB.ai"
import secondaryDownload3 from "../../../../../assets/downloads/Secondary_CMYK_PDF.pdf"
import secondaryDownload4 from "../../../../../assets/downloads/Secondary_RGB_PDF.pdf"
import secondaryDownload5 from "../../../../../assets/downloads/Secondary_CMYK_JPG.jpg"
import secondaryDownload6 from "../../../../../assets/downloads/Secondary_RGB_JPG.jpg"
import secondaryDownload7 from "../../../../../assets/downloads/Secondary_RGB_PNG.png"
import colorPallete from "../../../../svg/colorPallete.svg"
import color1 from "../../../../../assets/downloads/Color_CMYK.ai"
import color2 from "../../../../../assets/downloads/Color_RGB.ai"
import color3 from "../../../../../assets/downloads/Color_RGB.ai"
import color4 from "../../../../../assets/downloads/Color_RGB.pdf"
import typefaceImg from "../../../../svg/typeface.svg"
import typeface1 from "../../../../../assets/downloads/Typeface.zip"
import typeface2 from "../../../../../assets/downloads/Typeface_English.zip"
import typeface3 from "../../../../../assets/downloads/Typeface_Nepali.zip"
import { Col, Row } from 'reactstrap'
import communication1 from "../../../../../assets/kangaroo/communication1.jpg"
import communication2 from "../../../../../assets/kangaroo/communication2.jpg"
import communication3 from "../../../../../assets/kangaroo/communication3.jpg"
import communication4 from "../../../../../assets/kangaroo/communication4.jpg"
import communication5 from "../../../../../assets/kangaroo/communication5.jpg"
import communication6 from "../../../../../assets/kangaroo/communication6.jpg"
import communication7 from "../../../../../assets/kangaroo/communication7.jpg"
import communication8 from "../../../../../assets/kangaroo/communication8.jpg"
import communication9 from "../../../../../assets/kangaroo/communication9.jpg"
import communication10 from "../../../../../assets/kangaroo/communication10.jpg"
import communication11 from "../../../../../assets/kangaroo/communication11.jpg"
import communication12 from "../../../../../assets/kangaroo/communication12.jpg"
import communication13 from "../../../../../assets/kangaroo/communication13.jpg"
import communication14 from "../../../../../assets/kangaroo/communication14.jpg"
import communication15 from "../../../../../assets/kangaroo/communication15.jpg"
import communication16 from "../../../../../assets/kangaroo/communication16.jpg"
import brandCommunication from "../../../../../assets/kangaroo/brandcommunication1.jpg"
import brandCommunication2 from "../../../../../assets/kangaroo/brandcommunication2.jpg"
import brandDownload1 from "../../../../../assets/downloads/brand_CMYK.ai"
import brandDownload2 from "../../../../../assets/downloads/brand_RGB.ai"
import brandDownload3 from "../../../../../assets/downloads/MessageTemplate_CMYK.ai"
import brandDownload4 from "../../../../../assets/downloads/MessageTemplate_RGB.ai"
import salesImg1 from "../../../../../assets/kangaroo/salesImg1.jpg"
import salesImg2 from "../../../../../assets/kangaroo/salesImg2.jpg"
import salesImg3 from "../../../../../assets/kangaroo/salesImg3.jpg"
import salesImg4 from "../../../../../assets/kangaroo/salesImg4.jpg"
import salesImg5 from "../../../../../assets/kangaroo/salesImg5.jpg"
import salesImg6 from "../../../../../assets/kangaroo/salesImg6.jpg"
import corporateImg1 from "../../../../../assets/kangaroo/corporateImg1.jpg"
import corporateImg2 from "../../../../../assets/kangaroo/corporateImg2.jpg"
import corporateImg3 from "../../../../../assets/kangaroo/corporateImg3.jpg"
import corporateImg4 from "../../../../../assets/kangaroo/corporateImg4.jpg"
import corporateImg5 from "../../../../../assets/kangaroo/corporateImg5.jpg"
import corporateImg6 from "../../../../../assets/kangaroo/corporateImg6.jpg"
import corporateImg7 from "../../../../../assets/kangaroo/corporateImg7.jpg"
import marketingImg1 from "../../../../../assets/kangaroo/corporateMImg1.jpg"
import marketingImg2 from "../../../../../assets/kangaroo/corporateMImg2.jpg"
import marketingImg3 from "../../../../../assets/kangaroo/corporateMImg3.jpg"
import marketingImg4 from "../../../../../assets/kangaroo/corporateMImg4.jpg"
import marketingImg5 from "../../../../../assets/kangaroo/corporateMImg5.jpg"
import marketingImg6 from "../../../../../assets/kangaroo/corporateMImg6.jpg"
import marketingImg7 from "../../../../../assets/kangaroo/corporateMImg7.jpg"
import marketingImg8 from "../../../../../assets/kangaroo/corporateMImg8.jpg"
import marketingImg9 from "../../../../../assets/kangaroo/corporateMImg9.jpg"
import marketingImg10 from "../../../../../assets/kangaroo/corporateMImg10.jpg"
import marketingImg11 from "../../../../../assets/kangaroo/corporateMImg11.jpg"
import marketingDownload1 from "../../../../../assets/downloads/corporateMaterial1.ai"
import marketingDownload2 from "../../../../../assets/downloads/corporateMaterial2.ai"
import marketingDownload3 from "../../../../../assets/downloads/corporateMaterial3.ai"
import marketingDownload4 from "../../../../../assets/downloads/corporateMaterial4.ai"
import marketingDownload5 from "../../../../../assets/downloads/corporateMaterial5.ai"
import marketingDownload6 from "../../../../../assets/downloads/corporateMaterial6.ai"
import marketingDownload7 from "../../../../../assets/downloads/corporateMaterial7.ai"
import marketingDownload8 from "../../../../../assets/downloads/corporateMaterial8.ai"
import marketingDownload9 from "../../../../../assets/downloads/corporateMaterial9.jpg"
import marketingDownload10 from "../../../../../assets/downloads/corporateMaterial10.ai"
import marketingDownload11 from "../../../../../assets/downloads/corporateMaterial11.jpg"
import marketingDownload12 from "../../../../../assets/downloads/corporateMaterial12.ai"
import marketingDownload13 from "../../../../../assets/downloads/corporateMaterial13.ai"
import marketingDownload14 from "../../../../../assets/downloads/corporateMaterial14.ai"
import marketingDownload15 from "../../../../../assets/downloads/corporateMaterial15.ai"
import marketingDownload16 from "../../../../../assets/downloads/corporateMaterial16.ai"
import marketingDownload17 from "../../../../../assets/downloads/corporateMaterial17.ai"
import marketingDownload18 from "../../../../../assets/downloads/corporateMaterial18.ai"

import salesDownload1 from "../../../../../assets/downloads/product_CMYK.ai"
import salesDownload2 from "../../../../../assets/downloads/product_RGB.ai"
import salesDownload3 from "../../../../../assets/downloads/product1_CMYK.ai"
import salesDownload4 from "../../../../../assets/downloads/product1_RGB.ai"
import salesDownload5 from "../../../../../assets/downloads/product2_CMYK.ai"
import salesDownload6 from "../../../../../assets/downloads/product2_RGB.ai"
import salesDownload7 from "../../../../../assets/downloads/product3_CMYK.ai"
import salesDownload8 from "../../../../../assets/downloads/product3_RGB.ai"
import salesDownload9 from "../../../../../assets/downloads/product4_CMYK.ai"
import salesDownload10 from "../../../../../assets/downloads/product4_RGB.ai"
import salesDownload11 from "../../../../../assets/downloads/product5_CMYK.ai"
import salesDownload12 from "../../../../../assets/downloads/product5_RGB.ai"
import corporateDownload1 from "../../../../../assets/downloads/corporateDownload1.ai"
import corporateDownload2 from "../../../../../assets/downloads/corporateDownload2.ai"
import corporateDownload3 from "../../../../../assets/downloads/corporateDownload3.ai"
import corporateDownload4 from "../../../../../assets/downloads/corporateDownload4.ai"
import corporateDownload5 from "../../../../../assets/downloads/corporateDownload5.ai"
import corporateDownload6 from "../../../../../assets/downloads/corporateDownload6.ai"
import corporateDownload7 from "../../../../../assets/downloads/corporateDownload7.ai"
import corporateDownload8 from "../../../../../assets/downloads/corporateDownload8.ai"
import corporateDownload9 from "../../../../../assets/downloads/corporateDownload9.ai"
import corporateDownload10 from "../../../../../assets/downloads/corporateDownload10.ai"
import corporateDownload11 from "../../../../../assets/downloads/corporateDownload11.ai"
import corporateDownload12 from "../../../../../assets/downloads/corporateDownload12.ai"
import corporateDownload13 from "../../../../../assets/downloads/corporateDownload13.ai"
import corporateDownload14 from "../../../../../assets/downloads/corporateDownload14.ai"
import presentationData from "../../../../../assets/downloads/PresentationTemplate.pptx"


const Artwork = () => {
    const artworkData = useMemo(() => [
        {
            id: 1,
            title: "Primary Logo",
            image: primaryLogo,
            downloads: [
                { label: "Adobe Illustrator - CMYK", file: primaryDownload1 },
                { label: "Adobe Illustrator - RGB", file: primaryDownload2 },
                { label: "PDF - CMYK", file: primaryDownload3 },
                { label: "PDF - RGB", file: primaryDownload4 },
                { label: "JPEG - CMYK", file: primaryDownload5 },
                { label: "JPEG - RGB", file: primaryDownload6 },
                { label: "PNG - RGB", file: primaryDownload7 }
            ]
        },
        {
            id: 2,
            title: "Secondary Logo",
            image: secondaryLogo,
            downloads: [
                { label: "Adobe Illustrator - CMYK", file: secondaryDownload1 },
                { label: "Adobe Illustrator - RGB", file: secondaryDownload2 },
                { label: "PDF - CMYK", file: secondaryDownload3 },
                { label: "PDF - RGB", file: secondaryDownload4 },
                { label: "JPEG - CMYK", file: secondaryDownload5 },
                { label: "JPEG - RGB", file: secondaryDownload6 },
                { label: "PNG - RGB", file: secondaryDownload7 }
            ]
        }
    ], []);

    const colorData = useMemo(() => [
        {
            id: 1,
            title: "Primary & Secondary Color Palette",
            image: colorPallete,
            isFull: true,
            downloads: [
                { label: "Primary & Secondary Color Palette - CMYK (Adob Illustrator Format)", file: color1 },
                { label: "Primary & Secondary Color Palette - CMYK (PDF Format)", file: color2 },
                { label: "Primary & Secondary Color Palette - RGB (Adob Illustrator Format)", file: color3 },
                { label: "Primary & Secondary Color Palette - RGB (PDF Format)", file: color4 },
            ]
        },
    ], []);

    const typefaceData = useMemo(() => [
        {
            id: 1,
            title: "Primary & Secondary Typeface",
            image: typefaceImg,
            isFull: true,
            downloads: [
                { label: "Primary Typeface", file: typeface1 },
                { label: "Secondary Typeface - English", file: typeface2 },
                { label: "Secondary Typeface - Nepali", file: typeface3 },
            ]
        },
    ], []);

    const communicationData = useMemo(() => [
        { image: communication1, file: communication1, text: "pic1" },
        { image: communication2, file: communication2, text: "pic2" },
        { image: communication3, file: communication3, text: "pic3" },
        { image: communication4, file: communication4, text: "pic4" },
        { image: communication5, file: communication5, text: "pic5" },
        { image: communication6, file: communication6, text: "pic6" },
        { image: communication7, file: communication7, text: "pic7" },
        { image: communication8, file: communication8, text: "pic8" },
        { image: communication9, file: communication9, text: "pic9" },
        { image: communication10, file: communication10, text: "pic10" },
        { image: communication11, file: communication11, text: "pic11" },
        { image: communication12, file: communication12, text: "pic12" },
        { image: communication13, file: communication13, text: "pic13" },
        { image: communication14, file: communication14, text: "pic14" },
        { image: communication15, file: communication15, text: "pic15" },
        { image: communication16, file: communication16, text: "pic16" }
    ], []);

    const brandCommunicationData = useMemo(() => [
        {
            id: 1,
            title: "Brand Visual Mark Template",
            image: brandCommunication,
            downloads: [
                { label: "Brand Visual Mark Template - CMYK (Adobe Illustrator Format)", file: brandDownload1 },
                { label: "Brand Visual Mark Template - RGB (Adobe Illustrator Format)", file: brandDownload2 },

            ]
        },
        {
            id: 2,
            title: "Brand Visual Mark with Messaging Template",
            image: brandCommunication2,
            downloads: [
                { label: "Brand Visual Mark with Messaging Template - CMYK (Adobe Illustrator Format)", file: brandDownload3 },
                { label: "Brand Visual Mark with Messaging Template - RGB (Adobe Illustrator Format)", file: brandDownload4 },

            ]
        },
    ], []);

    const salesCommunicationData = useMemo(() => [
        {
            id: 1,
            title: "Product, Services & Partnership Showcase 1",
            image: salesImg1,
            downloads: [
                { label: "Product, Services & Partnership 1 Template - CMYK (Adobe Illustrator Format)", file: salesDownload1 },
                { label: "Product, Services & Partnership 1 Template - RGB (Adobe Illustrator Format)", file: salesDownload2 },

            ]
        },
        {
            id: 2,
            title: "Product, Services & Partnership Showcase 2",
            image: salesImg2,
            downloads: [
                { label: "Product, Services & Partnership 2 Template - CMYK (Adobe Illustrator Format)", file: salesDownload3 },
                { label: "Product, Services & Partnership 2 Template - RGB (Adobe Illustrator Format)", file: salesDownload4 },

            ]
        },
        {
            id: 3,
            title: "Product, Services & Partnership Showcase 3",
            image: salesImg3,
            downloads: [
                { label: "Product, Services & Partnership 3 Template - CMYK (Adobe Illustrator Format)", file: salesDownload5 },
                { label: "Product, Services & Partnership 3 Template - RGB (Adobe Illustrator Format)", file: salesDownload6 },

            ]
        },
        {
            id: 4,
            title: "Program, Event & Fair Template 1",
            image: salesImg4,
            downloads: [
                { label: "Program, Event & Fair 1 Template - CMYK (Adobe Illustrator Format)", file: salesDownload7 },
                { label: "Program, Event & Fair 1 Template - RGB (Adobe Illustrator Format)", file: salesDownload8 },

            ]
        },
        {
            id: 5,
            title: "Program, Event & Fair Template 2",
            image: salesImg5,
            downloads: [
                { label: "Program, Event & Fair 2 Template - CMYK (Adobe Illustrator Format)", file: salesDownload9 },
                { label: "Program, Event & Fair 2 Template - RGB (Adobe Illustrator Format)", file: salesDownload10 },

            ]
        },
        {
            id: 6,
            title: "Visa Achievement Announcement",
            image: salesImg6,
            downloads: [
                { label: "Visa Achievement Announcement Template - CMYK (Adobe Illustrator Format)", file: salesDownload11 },
                { label: "Visa Achievement Announcement Template - RGB (Adobe Illustrator Format)", file: salesDownload12 },

            ]
        },
    ], []);

    const corporateCommunicationData = useMemo(() => [
        {
            id: 1,
            title: "Seasonal Celebration 1",
            image: corporateImg1,
            downloads: [
                { label: "Seasonal Celebration 1 - CMYK (Adobe Illustrator Format)", file: corporateDownload1 },
                { label: "Seasonal Celebration 1 - RGB (Adobe Illustrator Format)", file: corporateDownload2 },

            ]
        },
        {
            id: 2,
            title: "Seasonal Celebration 2",
            image: corporateImg2,
            downloads: [
                { label: "Seasonal Celebration 2 - CMYK (Adobe Illustrator Format)", file: corporateDownload3 },
                { label: "Seasonal Celebration 2 - RGB (Adobe Illustrator Format)", file: corporateDownload4 },

            ]
        },
        {
            id: 3,
            title: "Birthday Celebration ",
            image: corporateImg3,
            downloads: [
                { label: "Birthday Celebration - CMYK (Adobe Illustrator Format)", file: corporateDownload5 },
                { label: "Birthday Celebration - RGB (Adobe Illustrator Format)", file: corporateDownload6 },

            ]
        },
        {
            id: 4,
            title: "Congratulations & Felicitation 1",
            image: corporateImg4,
            downloads: [
                { label: "Congratulations & Felicitation 1 - CMYK (Adobe Illustrator Format)", file: corporateDownload7 },
                { label: "Congratulations & Felicitation 1 - RGB (Adobe Illustrator Format)", file: corporateDownload8 },

            ]
        },
        {
            id: 5,
            title: "Congratulations & Felicitation 2",
            image: corporateImg5,
            downloads: [
                { label: "Congratulations & Felicitation 2 - CMYK (Adobe Illustrator Format)", file: corporateDownload9 },
                { label: "Congratulations & Felicitation 2 - RGB (Adobe Illustrator Format)", file: corporateDownload10 },

            ]
        },
        {
            id: 6,
            title: "Notice & Announcement 1",
            image: corporateImg6,
            downloads: [
                { label: "Notice & Announcement 1 - CMYK (Adobe Illustrator Format)", file: corporateDownload11 },
                { label: "Notice & Announcement 1 - RGB (Adobe Illustrator Format)", file: corporateDownload12 },

            ]
        },
        {
            id: 7,
            title: "Notice & Announcement 2",
            image: corporateImg7,
            downloads: [
                { label: "Notice & Announcement 2 - CMYK (Adobe Illustrator Format)", file: corporateDownload13 },
                { label: "Notice & Announcement 2 - RGB (Adobe Illustrator Format)", file: corporateDownload14 },

            ]
        },

    ], []);

    const marketingMaterialData = useMemo(() => [
        {
            id: 1,
            title: "Business Card",
            image: marketingImg1,
            downloads: [
                { label: "Business Card - CMYK (Adobe Illustrator Format)", file: marketingDownload1 },

            ]
        },
        {
            id: 2,
            title: "Identity Card",
            image: marketingImg2,
            downloads: [
                { label: "Identity Card - CMYK (Adobe Illustrator Format)", file: marketingDownload2 },


            ]
        },
        {
            id: 3,
            title: "Letterhead",
            image: marketingImg3,
            downloads: [
                { label: "Letterhead - CMYK (Adobe Illustrator Format)", file: marketingDownload3 },

            ]
        },
        {
            id: 4,
            title: "Envelope 1",
            image: marketingImg4,
            downloads: [
                { label: "Envelope 1 - CMYK (Adobe Illustrator Format)", file: marketingDownload4 },
                { label: "Envelope 2 - CMYK (Adobe Illustrator Format)", file: marketingDownload5 },

            ]
        },
        {
            id: 5,
            title: "Certificate",
            image: marketingImg5,
            downloads: [
                { label: "Certificate 1 - CMYK (Adobe Illustrator Format)", file: marketingDownload6 },
                { label: "Certificate 2 - CMYK (Adobe Illustrator Format)", file: marketingDownload7 },

            ]
        },
        {
            id: 6,
            title: "Presentation Frame",
            image: marketingImg6,
            downloads: [
                { label: "Presentation Starting Frame Template - RGB (Adobe Illustrator Format)", file: marketingDownload8 },
                { label: "Presentation Starting Frame Template - RGB (JPEG Format)", file: marketingDownload9 },
                { label: "Presentation Inside Frame Template - RGB (Adobe Illustrator Format)", file: marketingDownload10 },
                { label: "Presentation Inside Frame Template - RGB (JPEG Format)", file: marketingDownload11 },
                { label: "Presentation Template (PPTX Format)", file: presentationData },

            ]
        },
        {
            id: 7,
            title: "Publication Cover",
            image: marketingImg7,
            downloads: [
                { label: "Publication Cover 1 - CMYK (Adobe Illustrator Format)", file: marketingDownload12 },
                { label: "Publication Cover 2 - CMYK (Adobe Illustrator Format)", file: marketingDownload13 },

            ]
        },
        {
            id: 8,
            title: "Notepad",
            image: marketingImg8,
            downloads: [
                { label: "Notepad Template - CMYK (Adobe Illustrator Format)", file: marketingDownload14 },


            ]
        },
        {
            id: 9,
            title: "Signage",
            image: marketingImg9,
            downloads: [
                { label: "Signage 1 Template - CMYK (Adobe Illustrator Format)", file: marketingDownload15 },
                { label: "Signage 2 Template - CMYK (Adobe Illustrator Format)", file: marketingDownload16 },


            ]
        },
        {
            id: 10,
            title: "In-House Activity",
            image: marketingImg10,
            downloads: [
                { label: "In-House Activity Template - CMYK (Adobe Illustrator Format)", file: marketingDownload17 },



            ]
        },
        {
            id: 11,
            title: "Photo Frame",
            image: marketingImg11,
            downloads: [
                { label: "Photo Frame Template - CMYK (Adobe Illustrator Format)", file: marketingDownload18 },



            ]
        },

    ], []);

    const handleDownload = useCallback((file, name) => {
        // Binary formats that browsers cannot preview — download directly via fetch+Blob
        const isBinaryAsset = file.match(/\.(ai|ps|eps|indd)(\?.*)?$/i);

        if (isBinaryAsset) {
            // Derive a safe filename: prefer the label, fall back to the URL basename
            const ext = file.match(/\.(ai|ps|eps|indd)/i)?.[0] ?? '';
            const safeFilename = name ? `${name}${ext}` : file.split('/').pop();

            fetch(file)
                .then((res) => {
                    if (!res.ok) throw new Error('Network response was not ok');
                    return res.blob();
                })
                .then((blob) => {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = safeFilename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                })
                .catch((err) => {
                    console.error('Download failed:', err);
                    // Last-resort fallback
                    window.open(file, '_blank');
                });
            return;
        }

        // For images, PDFs, ZIPs — open a styled preview tab as before
        const newWindow = window.open("", "_blank");
        if (newWindow) {
            newWindow.document.write(`
                <html>
                    <head>
                        <title>${name ? name : 'Artwork Asset'}</title>
                        <link rel="icon" href="/logo.svg" />
                        <style>
                            body { margin: 0; overflow: hidden; background-color: #121212; display: flex; flex-direction: column; height: 100vh; font-family: sans-serif; }
                            .header { padding: 15px 30px; background: #1e1e1e; display: flex; justify-content: space-between; align-items: center; box-shadow: 0 2px 10px rgba(0,0,0,0.5); z-index: 10; }
                            .title-text { color: #fff; font-size: 16px; font-weight: 500; }
                            .download-btn { background: #812990; color: white; border: none; padding: 10px 24px; border-radius: 6px; cursor: pointer; font-weight: bold; text-decoration: none; font-size: 14px; transition: background 0.2s; }
                            .download-btn:hover { background: #6a1a78; }
                            .content { flex: 1; width: 100%; height: 100%; position: relative; overflow: hidden; display: flex; justify-content: center; align-items: center; padding: 20px; box-sizing: border-box; }
                            .content img { max-width: 100%; max-height: 100%; object-fit: contain; box-shadow: 0 0 20px rgba(0,0,0,0.3); }
                            iframe { width: 100%; height: 100%; border: none; display: block; }
                        </style>
                    </head>
                    <body>
                        <div class="header">
                            <div class="title-text">${name ? name : 'Asset Preview'}</div>
                            <a class="download-btn" href="${file}" download="${name ? name : ''}">Download</a>
                        </div>
                        <div class="content">
                            ${file.match(/\.(jpeg|jpg|gif|png|svg)(\?.*)?$/i)
                    ? `<img src="${file}" alt="Asset Preview" />`
                    : `<iframe src="${file}"></iframe>`
                }
                        </div>
                    </body>
                </html>
            `);
            newWindow.document.close();
        } else {
            // Fallback if popup blocker intervenes
            window.open(file, "_blank");
        }
    }, []);
    return (
        <SectionContainer>
            <BreadCrumb items={[
                { title: "HOME", link: "/" },
                { title: "ARTWORK AND ASSETS", },

            ]} instituition={false} className="" />

            <h1 className="font-level-1" style={{ marginBottom: "5rem" }}>ARTWORK <br /> & ASSETS</h1>
            <hr className="line" />
            <h1 className="font-level-2" >LOGO</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {artworkData.map((item, index) => (
                <div key={item.id} style={{ marginBottom: "30px" }}>

                    <h3 className='country-paragraph-text'>{item.title}</h3>

                    <Row>
                        <Col lg={item.isFull ? 12 : 6} md={item.isFull ? 12 : 6} sm={12}>
                            <img src={item.image} alt={item.title} className="img-fluid w-100" loading="lazy" />
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col lg={6} md={6} sm={12}>

                            {item.downloads.map((file, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <span
                                        className="country-paragraph-text mb-3"
                                        style={{
                                            flex: 1,              // takes equal space
                                            maxWidth: "70%"       // optional: prevents overflow
                                        }}
                                    >
                                        {file.label}
                                    </span>

                                    <button
                                        style={{
                                            // same width for all buttons
                                            textAlign: "center",
                                            background: "transparent",
                                            border: "none",

                                            cursor: "pointer"
                                        }}
                                        className='country-paragraph-text mb-3'
                                        onClick={() => handleDownload(file.file, file.label)}
                                    >
                                        (DOWNLOAD)
                                    </button>
                                </div>
                            ))}
                            <hr className="line" style={{ marginBottom: index === artworkData.length - 1 ? "0rem" : "5rem", marginTop: "5rem", opacity: index === artworkData.length - 1 ? 0 : 0.25 }} />
                        </Col>
                    </Row>

                </div>
            ))}
            <hr className="line" />
            <h1 className="font-level-2" >COLOR PALETTE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {colorData.map((item) => (
                <div key={item.id} style={{ marginBottom: "30px" }}>

                    <h3 className='country-paragraph-text'>{item.title}</h3>

                    <Row>
                        <Col lg={item.isFull ? 12 : 6} md={item.isFull ? 12 : 6} sm={12}>
                            <img src={item.image} alt={item.title} className="img-fluid w-100" loading="lazy" />
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col lg={12} md={12} sm={12}>

                            {item.downloads.map((file, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",

                                    }}
                                >
                                    <span
                                        className="country-paragraph-text mb-3"
                                        style={{
                                            flex: 1,              // takes equal space
                                            maxWidth: "70%"       // optional: prevents overflow
                                        }}
                                    >
                                        {file.label}
                                    </span>

                                    <button
                                        style={{
                                            // same width for all buttons
                                            textAlign: "center",
                                            background: "transparent",
                                            border: "none",

                                            cursor: "pointer"
                                        }}
                                        className='country-paragraph-text mb-3'
                                        onClick={() => handleDownload(file.file, file.label)}
                                    >
                                        (DOWNLOAD)
                                    </button>
                                </div>
                            ))}

                        </Col>
                    </Row>

                </div>
            ))}
            <hr className="line" style={{ marginTop: "5rem" }} />
            <h1 className="font-level-2" >TYPEFACE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {typefaceData.map((item) => (
                <div key={item.id} style={{ marginBottom: "30px" }}>

                    <h3 className='country-paragraph-text'>{item.title}</h3>

                    <Row>
                        <Col lg={item.isFull ? 12 : 6} md={item.isFull ? 12 : 6} sm={12}>
                            <img src={item.image} alt={item.title} className="img-fluid w-100" loading="lazy" />
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col lg={6} md={6} sm={12}>

                            {item.downloads.map((file, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",

                                    }}
                                >
                                    <span
                                        className="country-paragraph-text mb-3"
                                        style={{
                                            flex: 1,              // takes equal space
                                            maxWidth: "70%"       // optional: prevents overflow
                                        }}
                                    >
                                        {file.label}
                                    </span>

                                    <button
                                        style={{
                                            // same width for all buttons
                                            textAlign: "center",
                                            background: "transparent",
                                            border: "none",

                                            cursor: "pointer"
                                        }}
                                        className='country-paragraph-text mb-3'
                                        onClick={() => handleDownload(file.file, file.label)}
                                    >
                                        (DOWNLOAD)
                                    </button>
                                </div>
                            ))}

                        </Col>
                    </Row>

                </div>
            ))}
            <hr className="line" style={{ marginTop: "5rem" }} />
            <h1 className="font-level-2" >PHOTOGRAPHS</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            <Row>
                {communicationData.map((item, index) => (
                    <Col lg={4} md={6} sm={12} key={index} className="mb-4">

                        <div style={{ textAlign: "center" }}>
                            <div
                                style={{
                                    width: "100%",
                                    overflow: "hidden",
                                    marginBottom: "10px"
                                }}
                            >
                                <img
                                    src={item.image}
                                    loading='lazy'
                                    alt="communication"
                                    className="img-fluid w-100"
                                    style={{
                                        // 👈 fixed height for all
                                        objectFit: "cover", marginBottom: "10px", height: "200px"
                                    }}
                                />
                            </div>

                            <div style={{ textAlign: "left" }}>

                                <button className="px-4 py-2 country-paragraph-text" style={{ backgroundColor: "white", color: "#812990", borderRadius: "5px", border: "1px solid #812990" }}
                                    onClick={() => handleDownload(item.file, item.text)}>Download </button>
                            </div>

                        </div>

                    </Col>
                ))}
            </Row>

            <hr className="line" />
            <h1 className="font-level-2" >BRAND COMMUNICATION TEMPLATE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {brandCommunicationData.map((item, index) => (
                <div key={item.id} style={{ marginBottom: "30px" }}>

                    <h3 className='country-paragraph-text'>{item.title}</h3>

                    <Row>
                        <Col lg={item.isFull ? 12 : 6} md={item.isFull ? 12 : 6} sm={12}>
                            <img src={item.image} alt={item.title} className="img-fluid w-100" loading="lazy" />
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col lg={10} md={10} sm={12}>

                            {item.downloads.map((file, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",

                                    }}
                                >
                                    <span
                                        className="country-paragraph-text mb-3"
                                        style={{
                                            flex: 1,              // takes equal space
                                            maxWidth: "70%"       // optional: prevents overflow
                                        }}
                                    >
                                        {file.label}
                                    </span>

                                    <button
                                        style={{
                                            // same width for all buttons
                                            textAlign: "center",
                                            background: "transparent",
                                            border: "none",

                                            cursor: "pointer"
                                        }}
                                        className='country-paragraph-text mb-3'
                                        onClick={() => handleDownload(file.file, file.label)}
                                    >
                                        (DOWNLOAD)
                                    </button>
                                </div>
                            ))}

                        </Col>
                        <hr className="line" style={{ marginBottom: index === brandCommunicationData.length - 1 ? "0rem" : "5rem", marginTop: "5rem", opacity: index === brandCommunicationData.length - 1 ? 0 : 0.25 }} />
                    </Row>

                </div>
            ))}
            <hr className="line " />
            <h1 className="font-level-2" >SALES COMMUNICATION TEMPLATE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {salesCommunicationData.map((item, index) => (
                <div key={item.id} style={{ marginBottom: "30px" }}>

                    <h3 className='country-paragraph-text'>{item.title}</h3>

                    <Row>
                        <Col lg={item.isFull ? 12 : 6} md={item.isFull ? 12 : 6} sm={12}>
                            <img src={item.image} alt={item.title} className="img-fluid w-100" loading="lazy" />
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col lg={10} md={10} sm={12}>

                            {item.downloads.map((file, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",

                                    }}
                                >
                                    <span
                                        className="country-paragraph-text mb-3"
                                        style={{
                                            flex: 1,              // takes equal space
                                            maxWidth: "70%"       // optional: prevents overflow
                                        }}
                                    >
                                        {file.label}
                                    </span>

                                    <button
                                        style={{
                                            // same width for all buttons
                                            textAlign: "center",
                                            background: "transparent",
                                            border: "none",

                                            cursor: "pointer"
                                        }}
                                        className='country-paragraph-text mb-3'
                                        onClick={() => handleDownload(file.file, file.label)}
                                    >
                                        (DOWNLOAD)
                                    </button>
                                </div>
                            ))}

                        </Col>
                        <hr className="line" style={{ marginBottom: index === salesCommunicationData.length - 1 ? "0rem" : "5rem", marginTop: "5rem", opacity: index === salesCommunicationData.length - 1 ? 0 : 0.25 }} />
                    </Row>

                </div>
            ))}
            <hr className="line" />
            <h1 className="font-level-2" >CORPORATE COMMUNICATION TEMPLATE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {corporateCommunicationData.map((item, index) => (
                <div key={item.id} style={{ marginBottom: "30px" }}>

                    <h3 className='country-paragraph-text'>{item.title}</h3>

                    <Row>
                        <Col lg={item.isFull ? 12 : 6} md={item.isFull ? 12 : 6} sm={12}>
                            <img src={item.image} alt={item.title} className="img-fluid w-100" loading="lazy" />
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col lg={10} md={10} sm={12}>

                            {item.downloads.map((file, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",

                                    }}
                                >
                                    <span
                                        className="country-paragraph-text mb-3"
                                        style={{
                                            flex: 1,              // takes equal space
                                            maxWidth: "70%"       // optional: prevents overflow
                                        }}
                                    >
                                        {file.label}
                                    </span>

                                    <button
                                        style={{
                                            // same width for all buttons
                                            textAlign: "center",
                                            background: "transparent",
                                            border: "none",

                                            cursor: "pointer"
                                        }}
                                        className='country-paragraph-text mb-3'
                                        onClick={() => handleDownload(file.file, file.label)}
                                    >
                                        (DOWNLOAD)
                                    </button>
                                </div>
                            ))}

                        </Col>
                        <hr className="line" style={{ marginBottom: index === corporateCommunicationData.length - 1 ? "0rem" : "5rem", marginTop: "5rem", opacity: index === corporateCommunicationData.length - 1 ? 0 : 0.25 }} />
                    </Row>

                </div>
            ))}
            <hr className="line" />
            <h1 className="font-level-2" >CORPORATE MATERIALS TEMPLATE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />

            {marketingMaterialData.map((item, index) => (
                <div key={item.id} style={{ marginBottom: "30px" }}>

                    <h3 className='country-paragraph-text'>{item.title}</h3>

                    <Row>
                        <Col lg={item.isFull ? 12 : 6} md={item.isFull ? 12 : 6} sm={12}>
                            <img src={item.image} alt={item.title} className="img-fluid w-100" loading="lazy" />
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col lg={10} md={10} sm={12}>

                            {item.downloads.map((file, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",

                                    }}
                                >
                                    <span
                                        className="country-paragraph-text mb-3"
                                        style={{
                                            flex: 1,              // takes equal space
                                            maxWidth: "70%"       // optional: prevents overflow
                                        }}
                                    >
                                        {file.label}
                                    </span>

                                    <button
                                        style={{
                                            // same width for all buttons
                                            textAlign: "center",
                                            background: "transparent",
                                            border: "none",

                                            cursor: "pointer"
                                        }}
                                        className='country-paragraph-text mb-3'
                                        onClick={() => handleDownload(file.file, file.label)}
                                    >
                                        (DOWNLOAD)
                                    </button>
                                </div>
                            ))}

                        </Col>
                        <hr className="line" style={{ marginBottom: index === marketingMaterialData.length - 1 ? "0rem" : "5rem", marginTop: "5rem", opacity: index === marketingMaterialData.length - 1 ? 0 : 0.25 }} />
                    </Row>

                </div>
            ))}
        </SectionContainer>
    )
}

export default Artwork